import 'css-chunk:src/app/containers/Home/ClientsView/EditClientDrawer.scss';export default {
  "EditClientDrawer": "_EditClientDrawer_170sq_1",
  "form": "_form_170sq_1",
  "submitButton": "_submitButton_170sq_1"
};